export default { tag: 'client@2.23.1' };